import React from 'react'
import PropTypes from 'prop-types'
// components
import sanitizedContentData from '@/components/shared/utils/sanitizedContentData'
// styles
import './styles.scss'

const Card = ({ imageSrc, title, description, link, target, dataIndex }) => {
  return (
    <article className="card-news" data-index={dataIndex}>
      <a href={link} target={target} rel="noopener noreferrer">
        <div className="card-news__image">
          <img src={imageSrc} alt={title} />
        </div>

        <div className="card-news__content">
          <h3 className="card-news__title" dangerouslySetInnerHTML={sanitizedContentData(title)} />
          <div
            className="card-news__description"
            dangerouslySetInnerHTML={sanitizedContentData(description)}
          />
        </div>
      </a>
    </article>
  )
}

Card.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  target: PropTypes.string,
  dataIndex: PropTypes.number,
}

export default Card
